import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

export default function getTradeNote(tradeRecordId) {
  if(!tradeRecordId){
    throw 'Missing trade record ID'
  }

	return new Promise((resolve, reject) => {
		axios.put(APIAddress, {'uri': `/u_trade_notes/${tradeRecordId}/`,
    'method': 'GET',
    'token': localStorage.getItem('token')})
		.then((res) => {
			resolve(res.data);
		})
		.catch((err) => {
			reject(err);
		})
	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/school/getTradeNote.js